<template>
  <div>
    <!-- <a  @click.prevent.stop="reset" class="column has-bg-light is-border-bottom">
      <i class="fal fa-undo"></i> Réinitialiser la selection
    </a> -->
    <div class="columns is-gapless">
      <div class="column">
        <div class="field">
          <div class="control is-border has-icons-right" id="filtername">
            <input ref="input"
              type="text" class="input is-light" v-model="input" @input="startSearch"
              placeholder="Rechercher dans la liste"
              :class="{'is-degrad-info has-text-white':input && input.length}">
            <span class="icon is-right is-size-3">
              <i class="fal fa-search"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-paddingless inner-scroll liste-users">
        <ul>
          <li class="columns is-vcentered column is-paddingless is-border-bottom" v-for="(r, i) in results"
              :key="r.pk" @click="select(r)">
            <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
              <avatar :item="r" :i="i"></avatar>
            </div>
            <div
              class="column is-padding-top-xsmall is-padding-bottom-xsmall is-paddingless-left is-paddingless-right is-size-5 is-overflow-hidden is-nowrap hover-degrad">
              {{r.name}}<br>
              <span class="has-text-grey is-size-6">{{r.profil_type | profilTypeLabel}}</span>&nbsp;
              <span class="has-text-black is-size-7" v-if="r.company_name">{{r.company_name}}</span>
            </div>
            <div class="column is-narrow actions is-padding-top-xsmall is-padding-bottom-xsmall">
              <a v-if="entitiesPk.includes(r.pk)" class="button is-circle is-success">
                <span class="icon is-small"><i class="fas fa-check"></i></span>
              </a>
              <a v-else class="button is-circle is-light">
                <span class="icon is-small"><i class="fal fa-plus"></i></span>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
  import { EntityMx, DefaultValues } from '../../mixins'

  export default {
    name: 'SellerSelection',
    mixins: [EntityMx, DefaultValues],
    data () {
      return {
        algoliaKeys: ['USER']
      }
    },
    computed: {
      canSubmit () {
        return this.entities.length > 0
      }
    },
    mounted: function () {
      this.$refs.input.focus()
    },
    methods: {
      submit () {
        this.$emit('submit', {entities: this.entities})
      },
      select (r) {
        if (this.entitiesPk.includes(r.pk)) {
          this.unselectEntity(r)
        } else {
          this.selectEntity(r)
        }
      }
    },
    created () {
      this.input = ''
      this.startSearch()
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/quickview/SellerSelection.vue